module.exports = __webpack_public_path__ + "img/left-arrow.7d73c88c.svg";